import { render, staticRenderFns } from "./ReptCompany.vue?vue&type=template&id=e6c04212&scoped=true&"
import script from "./ReptCompany.vue?vue&type=script&lang=js&"
export * from "./ReptCompany.vue?vue&type=script&lang=js&"
import style0 from "./ReptCompany.vue?vue&type=style&index=0&id=e6c04212&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c04212",
  null
  
)

export default component.exports